// Regex to capture video ID
const videoIdRegex = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/]+\/.+\/*|(?:v|e(?:mbed)?)+\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
let players = {};
var YouTubeInitialized = false;
var YouTubeCompliance = false;

// Create and inject Youtube script
const scriptTag = document.createElement('script');
const firstScriptTag = document.getElementsByTagName('script')[0];
scriptTag.src = '//www.youtube.com/iframe_api';
firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);

(function ($) {
  $(document).ready(function() {

    ppms.cm.api('getComplianceSettings', onFulfilled, console.error);

    // UWV consent change event
    document.addEventListener("setcompliancesettings", function(consent){
      ppms.cm.api('getComplianceSettings', onFulfilled, console.error);
    });

    function onFulfilled(types) {
      var status = 0;
      if (types.consents.custom_consent) {
        var status = parseInt(types.consents.custom_consent.status);
      }

      if (status == 1) {
        $('.video__consent').each(function(){
          $(this).fadeOut();
          YouTubeCompliance = true;
          if (YouTubeInitialized){
            // Youtube API already called back, run again
            onYouTubeIframeAPIReady();
          }
        });
      }
    }

    $('iframe').each(function(){
      if  (!$(this).attr('src')){
        return;
      }
      let domain = (new URL($(this).attr('src')));
      domain = domain.hostname.replace('www.','');
      if (['youtube-nocookie.com', 'youtube.com', 'anchor.fm'].includes(domain)) {
        $(this).parent().addClass('video__container--' + domain.replace('.','-'));
      }
    });
  });
})(jQuery);

// Youtube script initialized
function onYouTubeIframeAPIReady() {
  YouTubeInitialized = true;
  if (!YouTubeCompliance){
    return;
  }
  const videoParagraphs = document.querySelectorAll('.js-paragraph-video');

  // Loop through all video paragraphs
  videoParagraphs.forEach(videoParagraph => {

    // Consts
    const videoUrl = videoParagraph.querySelector('.field--name-field-video-link').innerText;
    const videoId = isAlphanumericWithDashes(videoUrl.trim()) ? videoUrl.trim() : videoUrl.trim().match(videoIdRegex)[1];
    const videoOverlay = videoParagraph.querySelector('.video__overlay');
    const videoDuration = videoParagraph.querySelector('.video__duration');
    const videoElement = videoParagraph.querySelector('.video__player');
    const videoTitle = videoParagraph.querySelector('.js-paragraph-video-title h2');

    if (!isAlphanumericWithDashes(videoId)){
      // no youtube id found
      return;
    }
    // Initialize Youtube player
    const player = players[videoId] = {
      isPlaying: false,
      overlay: videoOverlay,
      ytPlayer: new YT.Player(videoElement, {
        videoId: videoId,
        host: 'https://www.youtube-nocookie.com',
        playerVars: {
          'playsinline': 1,
          'controls': 1,
          'modestbranding': 1,
          'enablejsapi': '1;hl=nl;rel=0'
        },
        events: {
          onReady: function(event) {
            const duration = player.ytPlayer.getDuration();
            const title = player.ytPlayer.videoTitle;
            videoDuration.innerText = fancyTimeFormat(duration);
            if (title.length != 0){
              videoTitle.innerText = title;
            } else {
              videoTitle.remove();
            }

          }
        }
      })
    }

    // Bind user input events
    videoOverlay.addEventListener('click', () => {

      // Pause all other videos first
      Object.keys(players).forEach(playerId => {

        // Skip clicked video
        if(playerId == videoId) {
          return;
        }
        const currentPlayer = players[playerId];
        currentPlayer.isPlaying = false;
        currentPlayer.ytPlayer.pauseVideo();
        currentPlayer.overlay.classList.remove('is-hidden');
      })

      // Hide overlay and play video
      videoOverlay.classList['add']('is-hidden');
      player.ytPlayer['playVideo']();

      // // Toggle play state
      player.isPlaying = !player.isPlaying;

      // Scroll playing video to the center of the screen
      if(player.isPlaying) {
        videoParagraph.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    })
  })
}

function isAlphanumericWithDashes(input) {
  var regex = /^[a-zA-Z0-9\-]+$/;
  return regex.test(input);
}

function fancyTimeFormat(duration){
    // Hours, minutes and seconds
    var hrs = ~~(duration / 3600);
    var mins = ~~((duration % 3600) / 60);
    var secs = ~~duration % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    var ret = "";

    if (hrs > 0) {
        ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }

    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
}
